import ContractDetailsNew from "./ContractDetailsNew";
import DrivingLicenseNew from "./DrivingLicenseNew";
import SubscriptionNew from "./SubscriptionNew";

const Other = ({
  personalInfo,
  visaDetails,
  contractDetails,
  drivingLicenseDetails,
  subscriptionDetails,
  handleGetTableData,
  empPublicId,
  getEmployeeRegistrationData,
  currentEmployeeEditing = false,
}) => {
  return (
    <div>
      {/* Contract Details Section */}
      <ContractDetailsNew
        personalInfo={personalInfo}
        contractDetails={contractDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
        currentEmployeeEditing={currentEmployeeEditing}
      />

      <div className="h-1 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded my-8" />

      {/* Driving License Section */}
      <DrivingLicenseNew
        personalInfo={personalInfo}
        drivingDetails={drivingLicenseDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
      />

      <div className="h-1 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded my-8" />

      {/* Subscription Section */}
      <SubscriptionNew
        personalInfo={personalInfo}
        visaDetails={visaDetails}
        contractDetails={contractDetails}
        drivingLicenseDetails={drivingLicenseDetails}
        subscriptionDetails={subscriptionDetails}
        handleGetTableData={handleGetTableData}
        empPublicId={empPublicId}
        getEmployeeRegistrationData={getEmployeeRegistrationData}
        currentEmployeeEditing={currentEmployeeEditing}
      />
    </div>
  );
};

export default Other;
